import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-035c39f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "main" }

import { ref, computed, onMounted } from "vue";
import SearchBar from '@/components/SearchBar.vue';
import DataList from '@/components/DataList.vue';
import DetailDialog from '@/components/DetailDialog.vue';
import DetailDialogEnd from '@/components/DetailDialogEnd.vue';
import { getListData } from "@/service/main/system";
import XLSX from "xlsx";
import { ElMessage } from "element-plus";

interface DataItem {
  employeeName: string;
  group: string;
  date: string;
  communicationPlans: number|string;
  activePlans: number|string;
  endPlans: number|string;
  typeA: number|string;
  typeB: number|string;
  typeC: number|string;
  typeD: number|string;
  followUpRecords: number|string;
  followUpPlans: number|string;
  managerSuggestions: number|string;
  managerSuggestionPlans: number|string;
  aiSuggestions: number|string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PreSaleCommPlanStatistic',
  setup(__props) {

const data = ref<DataItem[]>([]);

const searchParams = ref<{ date?: string; employee?: string; group?: string }>({});


const loadData = () => {
  getListData('/main/preCommPlan/statistic', {
    date: searchParams.value.date,
    empId: searchParams.value.employee,
    deptId: searchParams.value.group
  }).then((res) => {
    data.value = res.map((item: any) => {
      return {
        employeeName: item.employeeName,
        group: item.groupName,
        date: item.dateStr,
        communicationPlans: item.communicationPlans,
        activePlans: item.activePlans,
        endPlans: item.endPlans,
        typeA: item.typeA,
        typeB: item.typeB,
        typeC: item.typeC,
        typeD: item.typeD,
        followUpRecords: item.followUpRecords,
        followUpPlans: item.followUpPlans,
        managerSuggestions: item.managerSuggestions,
        managerSuggestionPlans: item.managerSuggestionPlans,
        aiSuggestions: item.aiSuggestions
      }
    })
  })
};


const handleSearch = (params: { date?: string; employee?: string }) => {
  searchParams.value = params;
  loadData()
};
const currentRow = ref({})
const showDetails = (row: any) => {
  currentRow.value = row;
  visible.value = true;
};

const showEndDetails = (row: any) => {
  currentRow.value = row;
  visibleEnd.value = true;
};

const downloadData = () => {
  let exportData: any = [...data.value]
  // 加中文标题
  exportData = exportData.map((item: any) => {
    return {
      '员工姓名': item.employeeName,
      '部门': item.group,
      '日期': item.date,
      '总数': item.communicationPlans,
      '进行中': item.activePlans,
      '已成交': item.endPlans,
      'A类': item.typeA,
      'B类': item.typeB,
      'C类': item.typeC,
      'D类': item.typeD,
      '跟踪记录': item.followUpRecords,
      '跟踪计划': item.followUpPlans,
      '经理建议': item.managerSuggestions,
      '经理建议计划': item.managerSuggestionPlans,
      'AI建议': item.aiSuggestions
    }
  })
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();

  // 加框线
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, '统计数据.xlsx');
  ElMessage.success('数据已成功导出为 Excel 文件');
}

const hideDetails = () => {
  visible.value = false;
  visibleEnd.value = false;
  currentRow.value = {};
};

const visible = ref(false)
const visibleEnd = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SearchBar, { onSearch: handleSearch })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(DataList, {
        data: data.value,
        onShowDetails: showDetails,
        onShowEndDetails: showEndDetails,
        onDownloadData: downloadData
      }, null, 8, ["data"])
    ]),
    _createVNode(DetailDialog, {
      visible: visible.value,
      row: currentRow.value,
      onClose: hideDetails
    }, null, 8, ["visible", "row"]),
    _createVNode(DetailDialogEnd, {
      visible: visibleEnd.value,
      row: currentRow.value,
      onClose: hideDetails
    }, null, 8, ["visible", "row"])
  ]))
}
}

})